import { useContext } from "react";
import { ExecutorContext } from "../contexts/ExecutorContext";

export const useExecutor = () => useContext(ExecutorContext);
